



























import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import Hls from 'hls.js'
import { loadHlsVideo, getWindowVisibilityState, getVisibilityEventName } from 'utils/index'
@Component({
  components: {
  },
})
export default class Video extends Vue {
  @Prop() private src;
  @Prop() private isLiveStream!: boolean
  @Prop() private isPCStream!: boolean
  @Prop() private refreshTime!: boolean
  @Prop() private roomPic!: string
  @Prop({
    type: Boolean,
    default: false
  }) private showControls!: boolean;
  @Prop({
    type: Boolean,
    default: false
  }) private isVideoContain!: boolean;

  private showPlayBtn = true;
  private isSupportedHlsJS = Hls.isSupported()
  private isSupportedHls = false
  private player: any
  private VisibilityEventName = getVisibilityEventName()
  private isPreview = false
  private mounted() {
    this.listenVideoEvent()
    this.isSupportedHls = (this.$refs.mobilePlayer as any).canPlayType('application/x-mpegURL')
    document.addEventListener(this.VisibilityEventName, this.visibleHiddenNoPlay)
    this.isPreview = this.$route.query.isPreview === '1'
  }
  @Watch('refreshTime')
  private onRefreshTimeUpdate(newValue: number, oldValue: number) {
    if (newValue !== oldValue && this.player) {
     // 分享窗口，背景是窗口，辅流是摄像头,当窗口流断掉后，辅流是摄像头流,且窗口和摄像头分辨率不一致的时候回导致花屏幕，所以收到科技114的信令需要重新拉流
     this.player.stopLoad()
     this.player.destroy();
     this.player = null
     setTimeout(() => {
      this.loadVideo()
     }, 300)
    }
  }

  private get isMuted () {
    return this.$store.state.videoMuted
  }

  private listenVideoEvent() {
    const videoElm = (this.$refs.mobilePlayer as any)
    if (videoElm) {
      // videoElm.addEventListener('canplay', this.autoPlay);
      videoElm.addEventListener('pause', this.setShowPlayBtn);
      // 16、error：播放错误
      videoElm.addEventListener('error', this.videoError)
      // 播放时去掉播放按钮
      videoElm.addEventListener('play', this.hidePlayBtn)
    }
  }

  private removeListenVideoEvent() {
    const videoElm = (this.$refs.mobilePlayer as any)
    if (videoElm) {
      // videoElm.removeEventListener('canplay', this.autoPlay)
      videoElm.removeEventListener('pause', this.setShowPlayBtn);
      videoElm.removeEventListener('error', this.videoError)
      videoElm.removeEventListener('play', this.hidePlayBtn)
    }
  }

  private videoError(e) {
    console.log('视频出错了', e);
  }

  private hlsOnError() {
     this.player = null
     this.showPlayBtn = true
  }

  private visibleHiddenNoPlay() {
    const visibilityState = getWindowVisibilityState()
    console.log('visibilityState', visibilityState)
    if (visibilityState === 'hidden') {
      this.setShowPlayBtn()
    }
  }

  private setShowPlayBtn() {
    console.log('start pause');
    (this.$parent as any).stopReport();
    this.showPlayBtn = true;
  }

  private hidePlayBtn() {
    if (this.showPlayBtn === true) {
      this.showPlayBtn = false
    }
  }

  private playClick () {
    (this.$parent as any).startReportViewDuration()
    this.loadVideo()
    this.showPlayBtn = false;
  }

  private autoPlay () {
    console.log('can play')
    const videoElm = (this.$refs.mobilePlayer as any)
    if (!videoElm.playing) {
      console.log('auto play');
      (this.$refs.mobilePlayer as any).play()
      this.showPlayBtn = false;
    }
  }



  private loadVideo () {
    const videoElm = (this.$refs.mobilePlayer as any)
    if (!this.isSupportedHlsJS && this.isLiveStream) {
      videoElm.load()
      setTimeout(() => {
        videoElm.play()
      }, 100)
    } else {
      if (!this.player && this.src.includes('.m3u8')) {
        this.player = loadHlsVideo(videoElm, this.src, this.hlsOnError)
      } else {
        videoElm.play()
      }
    }
    // if (this.isLiveStream && this.isSupportedHlsJS) {
    //   this.player = loadHlsVideo(videoElm, this.src, this.hlsOnError)
    // } else {
    //   (this.$refs.mobilePlayer as any).load()
    //   setTimeout(() => {
    //     (this.$refs.mobilePlayer as any).play()
    //   }, 100)
    // }
  }

  private beforeDestroy() {
    this.removeListenVideoEvent()
    document.removeEventListener(this.VisibilityEventName, this.visibleHiddenNoPlay)
    if (this.player) {this.player.stopLoad()}
  }
}
